<template>
    <div class='e-input-group m-b-8'>
      <ejs-textbox :placeholder='SearchHolder' v-model='keywords' @keydown.native.enter='search'>
        <span class="icon hero-icon hero-icon-search"></span>
      </ejs-textbox>
    </div>
</template>
<script>
export default {
  name: 'SearchAreaSpectrum',
  data() {
    return {
      keywords: ''
    };
  },
  props: {
    SearchHolder: {
      type: String,
      default() {
        return '';
      },
    }
  },
  methods: {
    search() {
      this.$emit('do-search', this.keywords.trim());
    }
  }
};
</script>
<style>
</style>
